import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const RelatedPrdModal = styled.div`
  background-color: #fff;
  /* max-height: calc(-50px + 100vh); */
  max-height: 70vh;
  height: 100%;
  border-radius: 20px 20px 0 0;
  overflow: hidden;

  .content {
    background-color: #fff;
    height: calc(100% - 25px);
    overflow-x: hidden;
    overflow-y: auto;
    padding: 12px 20px 20px 20px;
    /* max-height: 523px; */
    padding-bottom: calc(constant(safe-area-inset-bottom) + 20px);
    padding-bottom: calc(env(safe-area-inset-bottom) + 20px);

    &.is-scroll {
      /* padding-bottom: 40px; */
      padding-bottom: calc(constant(safe-area-inset-bottom) + 40px);
      padding-bottom: calc(env(safe-area-inset-bottom) + 40px);
    }

    /* .item.type-simple .area-info .area-click .area-tag {
      display: inline-block;
      position: absolute;
      top: -31px;
      left: 6px;
      z-index: 2;

      .tag.tag-soldout {
        background-color: #777;
      }
    } */
  }

  .error-box {
    ${mixin.flex({
      direction: 'column',
      align: 'center',
      justify: 'center',
    })}
    min-height: 50vh;

    .text {
      text-align: center;
      line-height: 130%;
      font-size: 14px;
      color: #000;
    }

    .btn-more {
      width: 170px;
      margin-top: 20px;
      border-color: #000;

      .icon-before {
        width: 14px;
        height: 14px;

        + .text {
          margin-left: 5px;
        }

        svg {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    border-radius: ${mixin.pxToVw('20 20 0 0')};

    .content {
      height: calc(100% - ${mixin.pxToVw('25')});
      padding: ${mixin.pxToVw('12 20 20 20')};
      /* max-height: ${mixin.pxToVw('523')}; */
      padding-bottom: calc(
        constant(safe-area-inset-bottom) + ${mixin.pxToVw('20')}
      );
      padding-bottom: calc(env(safe-area-inset-bottom) + ${mixin.pxToVw('20')});

      &.is-scroll {
        /* padding-bottom: ${mixin.pxToVw('40')}; */
        padding-bottom: calc(
          constant(safe-area-inset-bottom) + ${mixin.pxToVw('40')}
        );
        padding-bottom: calc(
          env(safe-area-inset-bottom) + ${mixin.pxToVw('40')}
        );
      }

      .btn-more {
        width: ${mixin.pxToVw('170')};
        margin-top: ${mixin.pxToVw('20')};

        .icon-before {
          width: ${mixin.pxToVw('14')};
          height: ${mixin.pxToVw('14')};

          + .text {
            font-size: ${mixin.pxToVw('14')};
            margin-left: ${mixin.pxToVw('5')};
          }
        }
      }

      /* .item.type-simple .area-info .area-click .area-tag {
        top: ${mixin.pxToVw('-31')};
        left: ${mixin.pxToVw('6')};
      } */
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    max-height: none;
    height: auto;
    border-radius: 0;
    max-width: 717px;

    .modal-title {
      padding: 30px 52px 24px 32px;
      margin-bottom: 0;

      .title {
        text-align: left;
        font-size: 24px;
      }
    }

    .modal-close-btn {
      position: absolute;
      top: 12px;
      right: 12px;
    }

    .content {
      padding: 0 32px 32px 32px;
      max-height: 405px;

      &.is-scroll {
        padding-bottom: 32px;
      }
    }

    .error-box {
      min-height: 338px;

      > .text {
        color: #777;
      }

      .btn-more {
        height: 40px;

        svg {
          width: 14px;
          height: 14px;
        }
      }
    }

    &.type-shortform {
      height: 100%;
      width: 384px;
      overflow: hidden;
      .modal-close-btn {
        right: 16px;
        z-index: 2;
      }
      .modal-title {
        text-indent: -9999px;
        font-size: 0;
        padding: 12px 16px;
      }

      .content {
        padding: 12px 15px 24px 24px;
        max-height: none;

        &.is-scroll {
          padding-bottom: 24px;
        }

        .items-grid {
          ${mixin.flex({
            justify: 'flex-start',
            align: 'flex-start',
            direction: 'column',
          })};
          gap: 16px;
          padding-bottom: 24px;

          .type-simple {
            ${mixin.flex({
              justify: 'flex-start',
              align: 'flex-start',
              direction: 'row',
            })};
            width: 100%;
            gap: 16px;
            .area-img {
              width: 72px;
              height: 96px;
            }
            .area-info {
              flex: 1;
              .area-click {
                padding: 4px 0 0 0;
                .prdc-title {
                  display: block;
                  width: 100%;
                }
                .prdc-price,
                .area-tag {
                  margin-top: 6px;
                  display: inline-flex;
                  justify-content: flex-start;
                }
                .area-tag {
                  margin-left: 7px;
                  vertical-align: text-bottom;
                }
              }
              .like-pick {
                top: 4px;
                right: 4px;
              }
            }
          }
        }
      }
    }
  }
`;
